"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ProductsCarouselRenderer", {
  enumerable: true,
  get: function get() {
    return _ProductsCarouselRenderer.ProductsCarouselRenderer;
  }
});
exports.productsCarouselPlugin = exports["default"] = void 0;

var _component = _interopRequireDefault(require("@loadable/component"));

var _createPlugin = _interopRequireDefault(require("./createPlugin"));

var _ProductsCarouselRenderer = require("@peracto/peracto-blocks/dist/content/ProductsCarousel/Renderer/ProductsCarouselRenderer");

var _ProductsCarouselRenderer2 = require("@peracto/peracto-blocks-tailwind/dist/content/ProductsCarousel/Renderer/ProductsCarouselRenderer");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ProductsCarouselForm = (0, _component["default"])(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('./Form/ProductsCarouselForm'));
  });
});

var productsCarouselPlugin = function productsCarouselPlugin(settings) {
  return (0, _createPlugin["default"])(_objectSpread({
    Renderer: settings !== null && settings !== void 0 && settings.isTailwind ? _ProductsCarouselRenderer2.ProductsCarouselRenderer : _ProductsCarouselRenderer.ProductsCarouselRenderer,
    Controls: ProductsCarouselForm
  }, settings));
};

exports.productsCarouselPlugin = productsCarouselPlugin;
var productsCarousel = productsCarouselPlugin();
var _default = productsCarousel;
exports["default"] = _default;